import React, { useEffect, useState } from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";

const Container = ({ children }) => <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">{children}</div>;

export default function Contact() {
  const [f, setF] = useState({ first_name: "", last_name: "", email: "", phone: "", practice: "", description: "", consent: false });
  const [sent, setSent] = useState(false);
  const [content, setContent] = useState(null);
  useEffect(() => { api.get("/website/content").then(({ data }) => setContent(data || {})).catch(() => setContent({})); }, []);
  const c = content?.contact || {};
  const co = content?.company || content?.footer || {};
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const submit = async () => {
    if (!f.first_name || !f.email || !f.consent) { toast.error("Merci de compléter les champs requis et le consentement."); return; }
    try {
      await api.post("/leads", { ...f, services: ["Assistance administrative sur mesure"], need_type: "Je ne sais pas encore" });
      setSent(true); toast.success("Message envoyé");
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  return (
    <Container>
      <div className="grid lg:grid-cols-5 gap-10">
        <div className="lg:col-span-2">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">{c.overline || "Contact"}</span>
          <h1 className="mt-3 font-heading font-bold tracking-tight text-slate-900 text-3xl sm:text-4xl">{c.title || "Parlons de votre cabinet"}</h1>
          <p className="mt-4 text-slate-600 leading-relaxed">{c.description || "Notre équipe vous répond rapidement. Décrivez votre besoin, nous revenons vers vous."}</p>
          <div className="mt-8 space-y-4 text-sm text-slate-700">
            <div className="flex items-center gap-3"><Mail className="h-5 w-5 text-primary" /> {co.email || "contact@delya.ch"}</div>
            <div className="flex items-center gap-3"><Phone className="h-5 w-5 text-primary" /> {co.phone || "+41 22 000 00 00"}</div>
            <div className="flex items-center gap-3"><MapPin className="h-5 w-5 text-primary" /> {co.address || "Genève, Suisse"}</div>
          </div>
        </div>
        <div className="lg:col-span-3 bg-white rounded-2xl border border-slate-200 p-6 md:p-8">
          {sent ? (
            <div className="text-center py-12" data-testid="contact-success"><h2 className="font-heading font-semibold text-xl text-slate-900">Merci !</h2><p className="mt-2 text-slate-600">Votre message a bien été transmis à notre équipe.</p></div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div><Label>Prénom *</Label><Input value={f.first_name} onChange={(e) => set("first_name", e.target.value)} className="mt-1" data-testid="contact-firstname" /></div>
              <div><Label>Nom</Label><Input value={f.last_name} onChange={(e) => set("last_name", e.target.value)} className="mt-1" /></div>
              <div><Label>E-mail *</Label><Input type="email" value={f.email} onChange={(e) => set("email", e.target.value)} className="mt-1" data-testid="contact-email" /></div>
              <div><Label>Téléphone</Label><Input value={f.phone} onChange={(e) => set("phone", e.target.value)} className="mt-1" /></div>
              <div className="sm:col-span-2"><Label>Cabinet</Label><Input value={f.practice} onChange={(e) => set("practice", e.target.value)} className="mt-1" /></div>
              <div className="sm:col-span-2"><Label>Votre message</Label><Textarea rows={4} value={f.description} onChange={(e) => set("description", e.target.value)} className="mt-1" data-testid="contact-message" /></div>
              <label className="sm:col-span-2 flex items-start gap-3 cursor-pointer"><Checkbox checked={f.consent} onCheckedChange={(v) => set("consent", !!v)} data-testid="contact-consent" /><span className="text-sm text-slate-600">J'accepte que mes données soient utilisées pour traiter ma demande.</span></label>
              <Button className="sm:col-span-2 bg-primary" onClick={submit} data-testid="contact-submit">Envoyer</Button>
            </div>
          )}
        </div>
      </div>
    </Container>
  );
}
